module.exports = __webpack_public_path__ + "static/img/charles59_None_0ea01b46-b03a-4ea2-a6e7-e05851e367fa.4685c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/charles59_None_0ea01b46-b03a-4ea2-a6e7-e05851e367fa.png
// module id = Ctbj
// module chunks = 0